export default {
  title: 'Historique des modifications du menu',
  subtitle: 'Consultez qui a modifié les prix, la disponibilité et la visibilité pour {{company}} — et quand.',
  filters: {
    type: {
      label: 'Type',
    },
    item: {
      placeholder: 'Tous les éléments',
    },
    event: {
      label: 'Événement',
    },
  },
  columns: {
    when: 'Quand',
    who: 'Modifié par',
    type: 'Type',
    item: 'Élément',
    event: 'Événement',
    changes: 'Modifications',
  },
  types: {
    product: 'Produit',
    modifier: 'Modificateur',
  },
  events: {
    created: 'Créé',
    updated: 'Mis à jour',
    deleted: 'Supprimé',
  },
  fields: {
    name: 'Nom',
    description: 'Description',
    price: 'Prix',
    is_available: 'Disponibilité',
    is_visible: 'Visibilité',
    is_available_for_pickup: 'Disponibilité retrait',
    is_available_for_delivery: 'Disponibilité livraison',
  },
  booleans: {
    on: 'Disponible',
    off: 'Indisponible',
  },
  pagination: {
    previous: 'Précédent',
    next: 'Suivant',
  },
  causers: {
    orders_terminal: 'Terminal de commandes',
  },
  system: 'Système',
  empty_value: '—',
  toasts: {
    failed_to_load_data: "Échec du chargement de l'historique des modifications du menu",
  },
};
